<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card vx-card">
        <div class="card-body" v-loading="loading">
          <!-- <div class="d-flex justify-content-between align-items-right">
            <vs-button
              type="gradient"
              @click="newInvoice()"
              v-if="company_default.permission != 5"
            >
              <i class="fa fa-plus"></i>
              Nueva factura
            </vs-button>
          </div> -->
          <div class="d-flex justify-content-between align-items-center">
            <div class="row">
              <registers-per-page class="mt-6 ml-4"
                @changeNumPerPage="changeNumPerPage"
              ></registers-per-page>
              <search-filter class="mt-6"
                :perPage="perPage"
                :options="optionsFilter"
                :placeholder="'Nombre/Factura'"
                @executeSearch="search"
              ></search-filter>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Comprobante</label>
                  <el-select
                    placeholder=""
                    no-data-text="No hay datos."
                    no-match-text="No hay resultados."
                    v-model="type"
                    value-key="value"
                    name="currency"
                    size="small"
                    filterable
                    class="form-control form-control-sm"
                    aria-label=".form-control-sm"
                    @change="filterType"
                  >
                    <el-option
                      v-for="option in optionsType"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Moneda</label>
                  <el-select
                    placeholder=""
                    no-data-text="No hay datos."
                    no-match-text="No hay resultados."
                    v-model="currency"
                    value-key="value"
                    name="currency"
                    size="small"
                    filterable
                    class="form-control"
                    @change="filterCurrency"
                  >
                    <el-option
                      v-for="currency in optionsCurrency"
                      :key="currency.value"
                      :label="currency.label"
                      :value="currency.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Estado</label>
                  <el-select
                    placeholder=""
                    no-data-text="No hay datos."
                    no-match-text="No hay resultados."
                    v-model="status"
                    value-key="value"
                    name="status"
                    size="small"
                    filterable
                    clearable
                    class="form-control"
                    @change="filtersStatus"
                  >
                    <el-option
                      v-for="status in optionsStatus"
                      :key="status.value"
                      :label="status.label"
                      :value="status.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Hacienda</label>
                  <el-select
                    placeholder=""
                    no-data-text="No hay datos."
                    no-match-text="No hay resultados."
                    v-model="hacienda"
                    value-key="value"
                    name="hacienda"
                    size="small"
                    filterable
                    clearable
                    class="form-control"
                    @change="filtersHacienda"
                  >
                    <el-option
                      v-for="hacienda in optionsHacienda"
                      :key="hacienda.value"
                      :label="hacienda.label"
                      :value="hacienda.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              
              <!-- <h4 class="font-weight-bold">Lista de facturas</h4> -->
              
            </div>
            <div class="col-md-2">
              <vs-button
              type="gradient"
              @click="newInvoice()"
              v-if="company_default.permission != 5"
            >
              <i class="fa fa-plus"></i>
              Nueva factura
            </vs-button>
            </div>
            
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="row">
              <el-date-picker
                class="ml-4"
                @change="changeRangeDates"
                name="dateInit"
                v-model="dateInit"
                type="date"
                placeholder="Fecha inicial"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-date-picker
                @change="changeRangeDates"
                name="dateEnd"
                v-model="dateEnd"
                type="date"
                placeholder="Fecha final"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <vs-button class="float-right ml-2" color="red" @click="cleanAll()">
                <i class="fa fa-trash"></i>
                Limpiar
              </vs-button>
            </div>
          </div>

          <div
            id="data-list-list-view"
            class="data-list-container mt-5"
            v-if="items.length"
          >
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Número</vs-th>
                <vs-th>Tipo Comprobante</vs-th>
                <vs-th v-if="company_default.permission == 5"
                  >Número control</vs-th
                >
                <vs-th>Cliente</vs-th>
                <vs-th>Total</vs-th>
                <vs-th v-if="company_default.permission != 5"
                  >Monto pagado</vs-th
                >
                <vs-th v-if="company_default.permission != 5">Estado</vs-th>
                <vs-th>Fecha</vs-th>
                <vs-th>Hacienda</vs-th>
                <vs-th v-if="company_default.permission != 5">Acciones</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr
                    :data="item"
                    :key="indextr"
                    v-for="(item, indextr) in data"
                  >
                    <vs-td
                      ><router-link
                        class="link"
                        :to="{
                          name: 'detail-transaction',
                          params: { type: 'invoice', id: item.id }
                        }"
                      >
                        {{ item.reference }}
                      </router-link></vs-td
                    >
                    <vs-td>
                      {{ item.type == "invoice" ? "Factura" : "Tiquete" }}
                    </vs-td>
                    <vs-td v-if="company_default.permission == 5">
                      {{ item.control_number ? item.control_number : "S/N" }}
                    </vs-td>
                    <vs-td>
                      <router-link
                        v-if="!item.client.deleted_at"
                        class="link"
                        :to="{
                          name: 'client-detail',
                          params: { id: item.client.id }
                        }"
                      >
                        {{ item.client.name }}
                      </router-link>
                      <span v-else>
                        {{ item.client.name }}
                      </span>
                    </vs-td>
                    <vs-td>
                      <calc-price
                        :price="item.total"
                        :currency="item.currency_id"
                        :exchange_rate="1"
                      ></calc-price>
                    </vs-td>
                    <vs-td v-if="company_default.permission != 5">
                      <calc-price
                        :price="item.payment_amount"
                        :currency="item.currency_id"
                        :exchange_rate="1"
                      ></calc-price>
                    </vs-td>
                    <vs-td
                      class="d-flex position-relative"
                      v-if="company_default.permission != 5"
                    >
                      <div>
                        <status-payment
                          :total="item.total"
                          :payment_amount="item.payment_amount"
                          :hacienda="item.hacienda"
                          :note_totals="item.note_totals"
                        >
                        </status-payment>
                      </div>
                      <br />
                      <div
                        style="padding-top: 8px"
                        v-if="
                          item.payment_amount < item.total &&
                            item.note_totals.ncs.nc_total < item.total
                        "
                      >
                        <small
                          class="text-danger"
                          v-if="item.expiration_date.substr(0, 10) < today"
                        >
                          Vencida hace {{ item.days_expiration }}
                          {{ item.days_expiration > 1 ? "dias" : "dia" }}
                        </small>
                        <small
                          class="text-warning"
                          v-if="item.expiration_date.substr(0, 10) == today"
                        >
                          Vence hoy
                        </small>
                      </div>
                    </vs-td>
                    <vs-td>{{ item.created_at | moment("DD/MM/YYYY") }}</vs-td>
                    <vs-td>
                      <status-hacienda
                        :status="item.hacienda"
                      ></status-hacienda>
                    </vs-td>
                    <vs-td v-if="company_default.permission != 5">
                      <el-dropdown @command="listAction">
                        <i class="fa fa-cogs text-primary"></i>

                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="item.total > item.payment_amount"
                            :command="{
                              command: 'pay',
                              payload: { item: item }
                            }"
                            class="text-info"
                          >
                            <i class="fa fa-money-bill-alt"></i>
                            Pagar
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              invoiceExpiration(item.expiration_date) &&
                                item.payment_amount < item.total
                            "
                            :command="{
                              command: 'rp',
                              payload: { item: item }
                            }"
                            class="text-warning"
                          >
                            <i class="fa fa-envelope-open-text"></i>
                            Recordatorio de pago
                            {{
                              item.number_sent_remember_payment > 0
                                ? "(" + item.number_sent_remember_payment + ")"
                                : ""
                            }}
                          </el-dropdown-item>
                          <el-dropdown-item
                            :command="{
                              command: 'nc',
                              payload: { id: item.id }
                            }"
                            class="text-danger"
                          >
                            <i class="fa fa-minus-circle"></i>
                            Nota de crédito
                          </el-dropdown-item>
                          <el-dropdown-item
                            :command="{
                              command: 'nd',
                              payload: { id: item.id }
                            }"
                            class="text-success"
                          >
                            <i class="fa fa-plus-circle"></i>
                            Nota de débito
                          </el-dropdown-item>
                          <!-- <el-dropdown-item
                            :command="{
                              command: 'clone',
                              payload: { id: item.id }
                            }"
                            class="text-primary"
                          >
                            <i class="fa fa-clone"></i>
                            Clonar
                          </el-dropdown-item> -->

                          <!-- <el-dropdown-item
                            :command="{
                              command: 'recurring',
                              payload: { id: item.id }
                            }"
                            class="text-primary"
                          >
                            <i class="fa fa-clone"></i>
                            Hacer recurrente
                          </el-dropdown-item> -->
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>

          <div class="mt-4 text-center zatura-pagination" v-if="pageCount > 1">
            <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
          </div>

          <div
            class="col-md-12 text-center"
            v-if="!loading && items.length == 0"
          >
            <p>No hay Facturas</p>
          </div>
        </div>
      </div>
    </div>

    <!-- modal new item -->
    <vs-popup title="Apertura de Caja" :active.sync="newOpenBoxModal">
      <div class="col-md-12" v-loading="loading" element-loading-text="Guardando por favor espere">
        <form @submit.prevent="storeItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Apertura</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h4 class="">Fondo de Caja</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 text-center">
                    <h5 class="">Billetes</h5>
                  </div>
                  <div class="col-md-6 text-center">
                    <h5 class="">Monedas</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 text-center">
                    <div class="rTableHead" style="width: 34%">Denominación</div>
                    <div class="rTableHead" style="width: 33%">Cantidad</div>
                    <div class="rTableHead" style="width: 33%">Subtotal</div>
                  </div>
                  <div class="col-md-6 text-center">
                    <div class="rTableHead" style="width: 34%">Denominación</div>
                    <div class="rTableHead" style="width: 33%">Cantidad</div>
                    <div class="rTableHead" style="width: 33%">Subtotal</div>
                  </div>
                </div>
                <div class="rTableRow" style="position: relative">
                  <div class="rTableCell col-md-2">
                    <label>¢50000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b50000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b50000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b50000 * 50000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                  <div class="rTableCell col-md-2">
                    <label>¢500</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m500'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m500"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.m500 * 500 | currency({ symbol: '¢', fractionCount: 2 }) }}                    
                  </div>
                </div>
                <div class="rTableRow">
                  <div class="rTableCell col-md-2">
                    <label>¢20000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b20000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b20000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b20000 * 20000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                  <div class="rTableCell col-md-2">
                    <label>¢100</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m100'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m100"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.m100 * 100 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div>
                <div class="rTableRow">
                  <div class="rTableCell col-md-2">
                    <label>¢10000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b10000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b10000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b10000 * 10000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                  <div class="rTableCell col-md-2">
                    <label>¢50</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m50'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m50"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.m50 * 50 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div>
                <div class="rTableRow">
                  <div class="rTableCell col-md-2">
                    <label>¢5000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b5000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b5000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b5000 * 5000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                  <div class="rTableCell col-md-2">
                    <label>¢25</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m25'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m25"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.m25 * 25 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div>
                <div class="rTableRow">
                  <div class="rTableCell col-md-2">
                    <label>¢2000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b2000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b2000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b2000 * 2000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div>
                <div class="rTableRow">
                  <div class="rTableCell col-md-2">
                    <label>¢1000</label>
                  </div>
                  <div class="rTableCell col-md-2">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='b1000'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.b1000"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-2">
                    {{ item.b1000 * 1000 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-md-12">
                    <hr/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h5 class="">Monedas</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr/>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="col-md-12">
                    <div class="rTableHead" style="width: 33%">Denominación</div>
                    <div class="rTableHead" style="width: 33%">Cantidad</div>
                    <div class="rTableHead" style="width: 33%">Subtotal</div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="rTableCell col-md-4">
                    <label>¢500</label>
                  </div>
                  <div class="rTableCell col-md-4">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m500'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m500"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-4">
                    {{ item.m500 * 500 | currency({ symbol: '¢', fractionCount: 2 }) }}                    
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="rTableCell col-md-4">
                    <label>¢100</label>
                  </div>
                  <div class="rTableCell col-md-4">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m100'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m100"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-4">
                    {{ item.m100 * 100 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="rTableCell col-md-4">
                    <label>¢50</label>
                  </div>
                  <div class="rTableCell col-md-4">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m50'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m50"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-4">
                    {{ item.m50 * 50 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="rTableCell col-md-4">
                    <label>¢25</label>
                  </div>
                  <div class="rTableCell col-md-4">
                    <el-input-number
                      @change="changeTotal()"
                      controls-position="right"
                      name='m25'
                      :min="0"
                      :max="1000000000000"
                      v-model="item.m25"
                    ></el-input-number>
                  </div>
                  <div class="rTableCell col-md-4">
                    {{ item.m25 * 25 | currency({ symbol: '¢', fractionCount: 2 }) }}
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-md-12">
                    <!-- <text-input
                      name="amount"
                      :label="'Total'"
                      v-validate="'required|decimal:2'"
                      :error="errors.first('amount')"
                      v-model="item.amount"
                      data-vv-as="Total">
                    </text-input> -->
                    <div class="form-group">
                      <div class="row ml-2">
                        <label>Total</label>
                      </div>
                      <CurrencyInput
                        :value.sync="item.amount"
                        name="amount"
                        :error="errors.first('amount')"
                        data-vv-as="Total"
                        :label="'Total'"
                        :options="{ currency: 'CRC',
                                    locale: 'nl-NL',
                                    currencyDisplay: 'narrowSymbol',
                                    valueRange: {
                                      min: 0,
                                      max: 1000000000000
                                    },
                                    precision: 2,
                                    hideCurrencySymbolOnFocus: true,
                                    hideGroupingSeparatorOnFocus: true,
                                    hideNegligibleDecimalDigitsOnFocus: true,
                                    autoDecimalDigits: false,
                                    useGrouping: true,
                                    accountingSign: false }"
                      />
                    </div>
                  </div>

                  <div class="col-md-12 text-right p-t-20">
                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal new item -->

    <payment-modal
      @paymentExecuted="updateItem"
      @closeModal="closeModal()"
      :data="data_modal"
      :vis="payment_modal_visible"
    ></payment-modal>
    <payment-remember-modal
      @closeModal="closeModal()"
      :dataEmail="data_modal"
      :visible="show_modal_payment_remember"
    ></payment-remember-modal>
  </div>
</template>

<script>
import CalcPrice from "@/components/CalcPrice.vue";
import invoicesService from "@/services/invoices.service";
import openBoxesService from "@/services/open-boxes.service";
import PaymentModal from "@/components/PaymentModal.vue";
import PaymentRememberModal from "@/components/PaymentRememberModal.vue";
import StatusPayment from "@/components/StatusPayment.vue";
import StatusHacienda from "@/components/StatusHacienda.vue";
import SearchFilter from "@/components/SearchFilter.vue";
import RegistersPerPage from "@/components/RegistersPerPage";
import momentjs from "moment";
import { mapState } from "vuex";
import CurrencyInput from "@/components/CurrencyInput";

export default {
  name: "invoices",
  data() {
    return {
      today: "",
      items: [],
      loading: false,
      payment_modal_visible: false,
      show_modal_payment_remember: false,
      data_modal: {},
      searchData: {},
      openBox: null,
      currentPage: 1,
      pageCount: 0,
      perPage: 10,
      page: 1,
      optionsFilter: [],
      item: {
        b50000: "",
        b20000: "",
        b10000: "",
        b5000: "",
        b2000: "",
        b1000: "",
        m500: "",
        m100: "",
        m50: "",
        m25: "",
        amount: 0
      },
      newOpenBoxModal: false,
      dateInit: null,
      dateEnd: null,
      optionsCurrency: [
        { label: "Todos", value: 0 },
        { label: "Dolares", value: 1 },
        { label: "Colones", value: 2 },
      ],
      currency: null,
      optionsType: [
        { label: "Todos", value: "all" },
        { label: "Factura", value: "invoice" },
        { label: "Tiquete", value: "ticket" },
      ],
      type: null,
      optionsStatus: [
        { label: "Pagado", value: "pagado" },
        { label: "No Pagado", value: "no-pagado" },
        { label: "Pago Parcial", value: "pago-parcial" }
      ],
      status: null,
      optionsHacienda: [
        { label: "Aceptado", value: "aceptado" },
        { label: "Rechazado", value: "rechazado" },
        { label: "Enviado", value: "enviado" },
        { label: "Por Enviar", value: "por-enviar" },
      ],
      hacienda: null,
    };
  },
  computed: {
    ...mapState(["datatable_current_page", "company_default", "parameters"])
  },
  methods: {
    invoiceExpiration(expiration_date) {
      let expiration_date_format = this.$options.filters.moment(
        expiration_date,
        "YYYY-MM-DD"
      );
      if (expiration_date_format <= momentjs().format("YYYY-MM-DD")) {
        return true;
      } else {
        return false;
      }
    },
    changeRangeDates() {
      this.currentPage = 1;
      this.searchData.rangeDates =
        this.dateInit != null && this.dateEnd != null
          ? this.dateInit + "," + this.dateEnd
          : "";
      // if (this.searchData.rangeDates != "") this.setRangeDates();
      this.getInvoices(this.currentPage, this.searchData);
    },
    changeTotal() {
      this.item.amount = ((this.item.b50000 != '' && this.item.b50000 != undefined) ? this.item.b50000 * 50000 : 0) + 
                          ((this.item.b20000 != '' && this.item.b20000 != undefined) ? this.item.b20000 * 20000 : 0) + 
                          ((this.item.b10000 != '' && this.item.b10000 != undefined) ? this.item.b10000 * 10000 : 0) +
                          ((this.item.b5000 != '' && this.item.b5000 != undefined) ? this.item.b5000 * 5000 : 0) + 
                          ((this.item.b2000 != '' && this.item.b2000 != undefined) ? this.item.b2000 * 2000 : 0) + 
                          ((this.item.b1000 != '' && this.item.b1000 != undefined) ? this.item.b1000 * 1000 : 0) +
                          ((this.item.m500 != '' && this.item.m500 != undefined) ? this.item.m500 * 500 : 0) + 
                          ((this.item.m100 != '' && this.item.m100 != undefined) ? this.item.m100 * 100 : 0) + 
                          ((this.item.m50 != '' && this.item.m50 != undefined) ? this.item.m50 * 50 : 0) + 
                          ((this.item.m25 != '' && this.item.m25 != undefined) ? this.item.m25 * 25 : 0);
    },
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num;
      this.searchData = searchData;
      this.getInvoices(1, this.searchData);
    },
    filterCurrency() {
      this.searchData.currency = this.currency;
      this.getInvoices(1, this.searchData);
    },
    filterType() {
      this.searchData.type = this.type;
      this.getInvoices(1, this.searchData);
    },
    filtersStatus() {
      this.searchData.status = this.status;
      this.getInvoices(1, this.searchData);
    },
    filtersHacienda() {
      this.searchData.hacienda = this.hacienda;
      this.getInvoices(1, this.searchData);
    },
    cleanAll() {
      delete this.searchData.hacienda
      delete this.searchData.status
      delete this.searchData.type
      delete this.searchData.currency
      delete this.searchData.rangeDates
      this.searchData = ''
      this.dateInit = null
      this.dateEnd = null
      this.currency = null
      this.type = null
      this.status = null
      this.hacienda = null
      this.searchData = {}
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage;
      this.searchData.rangeDates =
        this.dateInit != null && this.dateEnd != null
          ? this.dateInit + "," + this.dateEnd
          : "";
      this.searchData.currency = this.currency;
      this.searchData.type = this.type;
      this.searchData.status = this.status;
      this.searchData.hacienda = this.hacienda;
      this.getInvoices(1, this.searchData);
    },
    goPage(page) {
      this.currentPage = page;
      this.getInvoices(page, this.searchData);
      this.$store.dispatch("updateCurrentPageDatatable", {
        page: page,
        section: "invoices"
      });
    },
    updateItem(item) {
      this.payment_modal_visible = false;
      let i = this.items.find(i => i.id === item.paymentable_id);
      let index = this.items.indexOf(i);
      this.items[index].payment_amount =
        this.items[index].payment_amount + parseFloat(item.amount);
      this.items[index].due = item.due;
      this.payment_modal_visible = false;
    },
    payout(total, payment_amount) {
      return total > payment_amount ? false : true;
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    newOpenBox() {
      this.resetForm();
      this.newOpenBoxModal = true;
    },
    storeItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let data = this.item;
          this.loading = true;
          openBoxesService.storeOpenBox(data)
          .then(() => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: 'Apertura guardada correctamente',
              type: 'success',
              duration: 1500
            });
            this.getTodaysOpenBox();
            this.newOpenBoxModal = false;
          })
          .catch(function (error) {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error.response.data.message,
              type: 'error'
            });
          });
        }
      });
    },
    getTodaysOpenBox() {
      openBoxesService.getTodaysOpenBox()
      .then((res) => {
        this.openBox = res.data.item;
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      });
    },
    newInvoice() {
      this.getTodaysOpenBox();
      if (this.openBox == null && this.parameters && this.parameters[0].value){
        this.$confirm('Se necesita aperturar la caja para facturar ¿ Desea Proceder ?', 'Apertura', {
          confirmButtonText: 'Si, continuar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          center: true
        }).then(() => {
          this.newOpenBox();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Acción cancelada'
          });
        });
      }
      else{
        this.$router.push({ name: "new-invoice" });
      }
      
    },
    getInvoices(page = 1, search = {}) {
      this.loading = true;
      invoicesService
        .getInvoices(page, search)
        .then(res => {
          this.items = res.data.data;
          this.loading = false;
          this.pageCount = res.data.last_page;
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error.message,
            type: "error"
          });
        });
    },
    closeModal(data) {
      this.payment_modal_visible = false;
      this.show_modal_payment_remember = false;
    },
    listAction(command) {
      switch (command.command) {
        case "pay":
          this.payment_modal_visible = true;
          this.data_modal = command.payload;
          break;
        case "nc":
          this.$router.push({
            name: "new-note",
            params: {
              note_type: "nc",
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "nd":
          this.$router.push({
            name: "new-note",
            params: {
              note_type: "nd",
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "clone":
          this.$router.push({
            name: "new-clone",
            params: {
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "recurring":
          this.$router.push({
            name: "new-recurring",
            params: {
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        //recordatorio de pago
        case "rp":
          this.show_modal_payment_remember = true;
          this.data_modal = command.payload;
          break;
      }
    }
  },
  components: {
    CalcPrice,
    PaymentModal,
    StatusPayment,
    StatusHacienda,
    SearchFilter,
    RegistersPerPage,
    PaymentRememberModal,
    CurrencyInput
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getInvoices(this.datatable_current_page.invoices);
    this.today = momentjs().format("YYYY-MM-DD");
    this.getTodaysOpenBox();
  }
};
</script>

<style scoped>
.rTableCell {
  height: 50px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rTableHead {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.titulo {
  color: white;
  background: #276C9F;
}
.subtitulo {
  color: white;
  background: #5f6971;
}
</style>
